<script>
export default {
  methods: {
    getCallTaskState (state) {
      switch (state) {
        case 'FAILED':
          return 'Недозвон'
        case 'DIALING':
          return 'Вызов'
        case 'ONGOING':
          return 'Идет разговор'
        case 'PERFORMED':
          return 'Выполнена'
        case 'POSTPONED':
          return 'Отложена'
        case 'READY':
          return 'В очереди'
        case 'TELEPHONY_ERROR_SUSPEND':
          return 'Отложена'
        case 'CANCELLED':
          return 'Отменена'
        default:
          return state
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// GetCalltaskState.vue?1f6b667c